import React from "react";
import Button from "components/comman/button";
import classes from "./createProjectTools.module.scss";
import { FaFilePdf } from "react-icons/fa";
// import { API } from "API/API";

function ProjectToolAction({ projectPdf, handleAddFilesBrochure, handleAddFilesSubmittal, handleEditProject, handleDeleteProject, handleUpdateProductIndex }) {

  return (
    <div className={classes.wrapper_actn}>
      <h3 className={classes.wrapper_actn_ttl}>Project Tools</h3>
      <div className={classes.wrapper_actn_text}>
        <p>
          Create submittals, edit your project data or delete your project
          entirely.
        </p>
      </div>
      <div className={classes.wrapper_actn_wrap}>
        {projectPdf && (
          <Button
            value={
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'center' }}>
                <FaFilePdf size={20} color="#e53e3e" />
                <span>PDF calculation result</span>
              </div>
            }
            type="secondary"
            grouClass={classes.wrapper_actn_wrap_btn}
            click={() => window.open(`${process.env.REACT_APP_IMAGE_BASEURL?.replace(/\/product-image\/?$/, "")}${projectPdf}`, "_blank")}
            style={{
              border: 'none'
            }}
          />
        )}
        <Button
          value="Create A Brochure"
          type="secondary"
          grouClass={classes.wrapper_actn_wrap_btn}
          click={handleUpdateProductIndex}

        />
        <Button
          value="Create A Submittal"
          type="secondary"
          grouClass={classes.wrapper_actn_wrap_btn}
          click={handleAddFilesSubmittal}

        />
        <Button
          value="Edit Project"
          type="primary"
          grouClass={classes.wrapper_actn_wrap_btn}
          click={handleEditProject}
          style={{ backgroundColor: '#0154A0  ' }}
        />
        <Button
          value="Delete Project"
          type="primary"
          grouClass={classes.wrapper_actn_wrap_btn}
          click={handleDeleteProject}
          style={{ backgroundColor: '#0154A0  ' }}
        />

      </div>
    </div>
  );
}

export default ProjectToolAction;
